import Restaurant from "../assets/Projects_Screenshots/restaurant.jpg";
import Box_Office from "../assets/Projects_Screenshots/Box_Office.jpg";
import Chat_app from "../assets/Projects_Screenshots/Chat_app.jpg";
import Keeper_app from "../assets/Projects_Screenshots/Keeper_app.jpg";
import Tic_tac_toe from "../assets/Projects_Screenshots/Tic_tac_toe.jpg";
import memories_blog from "../assets/Projects_Screenshots/memories_blog.jpg";
import ToDo_List from "../assets/Projects_Screenshots/ToDo_List.png";
import Task_Management from "../assets/Projects_Screenshots/task_management.jpg";
import Drum_Machine from "../assets/Projects_Screenshots/drum_machine.jpg";
import Markdown_Previewer from "../assets/Projects_Screenshots/markdown_preview.jpg";
import Calculator from "../assets/Projects_Screenshots/javascript_calculator.jpg";
import Clock from "../assets/Projects_Screenshots/Clock.jpg";


const myProjects = [
  {
    title: "Restaurant app",
    imageUrl: Restaurant,
    githubLink: "https://github.com/abhisheksharma1310/little-lemon",
    demoLink: "https://little-lemon-restaurant-web.netlify.app/",
  },
  {
    title: "Memories Blog",
    imageUrl: memories_blog,
    githubLink: "https://github.com/abhisheksharma1310/memories_blog",
    demoLink: "https://memoriesblogposts.netlify.app/",
  },
  {
    title: "Chat app",
    imageUrl: Chat_app,
    githubLink: "https://github.com/abhisheksharma1310/chat-app-react",
    demoLink: "https://chatwebreactapp.web.app/",
  },
  {
    title: "Box Office app",
    imageUrl: Box_Office,
    githubLink: "https://github.com/abhisheksharma1310/box-office-react-app",
    demoLink: "https://abhisheksharma1310.github.io/box-office-react-app/",
  },
  {
    title: "Task management app",
    imageUrl: Task_Management,
    githubLink: "https://github.com/abhisheksharma1310/task-management-app",
    demoLink: "https://task-management-app-sigma-indol.vercel.app/",
  },
  {
    title: "25 + 5 Clock app",
    imageUrl: Clock,
    githubLink: "https://github.com/abhisheksharma1310/25-5-clock",
    demoLink: "https://3pn73q.csb.app/",
  },
  {
    title: "Drum machine app",
    imageUrl: Drum_Machine,
    githubLink: "https://github.com/abhisheksharma1310/drum-machine",
    demoLink: "https://kv7m45.csb.app/",
  },
  {
    title: "Calculator app",
    imageUrl: Calculator,
    githubLink: "https://github.com/abhisheksharma1310/javascript-calculator",
    demoLink: "https://f9x9f2.csb.app/",
  },
  {
    title: "Markdown previewer app",
    imageUrl: Markdown_Previewer,
    githubLink: "https://github.com/abhisheksharma1310/markdown-previewer",
    demoLink: "https://cmpq2v.csb.app/",
  },
  {
    title: "Keeper app",
    imageUrl: Keeper_app,
    githubLink: "https://github.com/abhisheksharma1310/Keeper_app",
    demoLink: "https://abhisheksharma1310.github.io/Keeper_app",
  },
  {
    title: "Tic Tac Toe Game app",
    imageUrl: Tic_tac_toe,
    githubLink:
      "https://github.com/abhisheksharma1310/tictactoe-game-react-app",
    demoLink: "https://abh-tictactoegame-react.surge.sh/",
  },
  {
    title: "To-Do List app",
    imageUrl: ToDo_List,
    githubLink: "https://github.com/abhisheksharma1310/ToDo-List-app",
    demoLink: "https://abhisheksharma1310.github.io/ToDo-List-app",
  },
];

export default myProjects;
